import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const URLINTENT = "urlIntent";

/**
 * we use
 *  - universal-links on iOS - as it works ok there
 *  - universal-links on Android - configured via cordova-universal-links-plugin
 *  - urlScheme as fallback - for cases where universal links don't work
 */

// ===== cordova-plugin-customurlscheme approach =====
window.handleOpenURL = (url: string) => {
  if (window.urlListenerIsLoaded) {
    const path = url.split("com.duocards.app:/")[1] || url.split("app.duocards.com")[1];
    if (path) {
      var event = new CustomEvent(URLINTENT, { detail: path });
      document.dispatchEvent(event);
    }
  } else {
    setTimeout(() => {
      window.handleOpenURL?.(url);
    }, 500);
  }
};

const Linking: React.FC = () => {
  const navigate = useNavigate();

  // ===== cordova-plugin-customurlscheme approach =====
  const handleUrl = (e) => {
    try {
      navigate(e.detail);
    } catch (e) {}
  };
  useEffect(() => {
    document.addEventListener(URLINTENT, handleUrl);
    window.urlListenerIsLoaded = true;
    return () => document.removeEventListener(URLINTENT, handleUrl);
  });

  // ===== cordova-universal-links-plugin approach =====
  useEffect(() => {
    if (typeof window.cordova === "undefined" || !window.cordova?.exec) return;
    if (window.universalLinks?.subscribe) {
      const handleUniversalLink = (data: { path?: string; url?: string }) => {
        const match = data?.url?.match(/app\.duocards\.com(\/.*)?$/);
        match?.[1] && navigate(match[1]);
      };
      // subscribing twice, bacause when iOS starts DuoCards normally and without navigating yet, we use universal link, it isn't subscribed
      window.universalLinks?.subscribe?.("didLaunchAppFromLink", handleUniversalLink);
      window.universalLinks?.subscribe?.("didReceiveLink", handleUniversalLink);
      const timeoutId = setTimeout(() => {
        window.universalLinks?.subscribe?.("didLaunchAppFromLink", handleUniversalLink);
        window.universalLinks?.subscribe?.("didReceiveLink", handleUniversalLink);
      }, 1000);
      return () => {
        clearTimeout(timeoutId);
        window.universalLinks?.unsubscribe?.("didLaunchAppFromLink");
        window.universalLinks?.unsubscribe?.("didReceiveLink");
      };
    }
  }, [navigate]);

  return null;
};

export default Linking;
